/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Fairusefactors_Noncommercialbody4Inputs */

const id_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Situs web kami bersifat non-komersial dan berusaha meningkatkan pengetahuan publik tentang game Epic Games Store.`)
};

const ms_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laman web kami bukan komersial dan berusaha untuk meningkatkan pengetahuan orang ramai tentang permainan Epic Games Store.`)
};

const da_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vores hjemmeside er ikke-kommerciel og søger at forbedre offentlighedens viden om Epic Games Store spil.`)
};

const de_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsere Website ist nicht-kommerziell und versucht, das öffentliche Wissen über Epic Games Store-Spiele zu erweitern.`)
};

const en_us2_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our website is non-commercial and seeks to enhance public knowledge about Epic Games Store games.`)
};

const es_es2_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuestro sitio web es no comercial y busca mejorar el conocimiento público sobre los juegos de la Epic Games Store.`)
};

const es_mx2_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuestro sitio web es no comercial y busca mejorar el conocimiento público sobre los juegos de la Epic Games Store.`)
};

const fil_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang aming website ay di-komersyal at naglalayong pahusayin ang kaalaman ng publiko tungkol sa mga laro ng Epic Games Store.`)
};

const fr_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notre site web est non commercial et cherche à améliorer la connaissance du public sur les jeux de l'Epic Games Store.`)
};

const it_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il nostro sito web è non commerciale e cerca di migliorare la conoscenza pubblica sui giochi dell'Epic Games Store.`)
};

const hu_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weboldalunk nem kereskedelmi jellegű, és célja a nyilvánosság Epic Games Store játékokkal kapcsolatos ismereteinek bővítése.`)
};

const nl_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onze website is niet-commercieel en streeft ernaar de publieke kennis over Epic Games Store-games te vergroten.`)
};

const no_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nettstedet vårt er ikke-kommersielt og søker å øke offentlig kunnskap om Epic Games Store-spill.`)
};

const pl_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasza strona jest niekomercyjna i ma na celu poszerzanie wiedzy publicznej na temat gier z Epic Games Store.`)
};

const pt_br2_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nosso site não é comercial e busca aumentar o conhecimento público sobre os jogos Epic Games Store.`)
};

const pt_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O nosso website é não comercial e procura melhorar o conhecimento público sobre os jogos da Epic Games Store.`)
};

const ro_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Site-ul nostru este necomercial și urmărește să îmbunătățească cunoștințele publice despre jocurile din Epic Games Store.`)
};

const fi_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sivustomme on ei-kaupallinen ja pyrkii lisäämään yleistä tietämystä Epic Games Storen peleistä.`)
};

const sv_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vår webbplats är icke-kommersiell och syftar till att öka allmänhetens kunskap om spel i Epic Games Store.`)
};

const vi_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang web của chúng tôi phi thương mại và tìm cách nâng cao kiến thức công chúng về các game trên Epic Games Store.`)
};

const tr_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web sitemiz ticari değildir ve Epic Games Store oyunları hakkında kamu bilgisini artırmayı amaçlar.`)
};

const cs_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naše webové stránky jsou nekomerční a snaží se zlepšit veřejné znalosti o hrách na Epic Games Store.`)
};

const bg_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нашият уебсайт е некомерсиален и се стреми да подобри общественото познание за игрите на Epic Games Store.`)
};

const ru_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наш сайт является некоммерческим и стремится расширить общественные знания об играх в Epic Games Store.`)
};

const uk_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наш вебсайт є некомерційним і прагне підвищити обізнаність громадськості про ігри Epic Games Store.`)
};

const ar_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`موقعنا غير تجاري ويسعى إلى تعزيز المعرفة العامة حول ألعاب Epic Games Store.`)
};

const hi_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हमारी वेबसाइट गैर-वाणिज्यिक है।`)
};

const th_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เว็บไซต์ของเราไม่ใช่เชิงพาณิชย์และมุ่งหวังที่จะเพิ่มพูนความรู้สาธารณะเกี่ยวกับเกมใน Epic Games Store`)
};

const ja_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当ウェブサイトは非営利であり、Epic Games Store のゲームに関する一般の知識を高めることを目的としています。`)
};

const zh_cn2_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们的网站是非商业性的，旨在增强公众对Epic游戏商城游戏的知识。`)
};

const zh_hant1_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我們的網站是非商業性的，旨在增強大眾對Epic遊戲商城遊戲的知識。`)
};

const ko_privacy_fairusefactors_noncommercialbody4 = /** @type {(inputs: Privacy_Fairusefactors_Noncommercialbody4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`당사 웹사이트는 비상업적이며 Epic Games Store 게임에 대한 대중의 지식을 향상시키고자 합니다.`)
};

/**
* | output |
* | --- |
* | "Our website is non-commercial and seeks to enhance public knowledge about Epic Games Store games." |
*
* @param {Privacy_Fairusefactors_Noncommercialbody4Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const privacy_fairusefactors_noncommercialbody4 = /** @type {((inputs?: Privacy_Fairusefactors_Noncommercialbody4Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Fairusefactors_Noncommercialbody4Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "ms") return ms_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "da") return da_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "de") return de_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "en-US") return en_us2_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "es-ES") return es_es2_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "es-MX") return es_mx2_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "fil") return fil_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "fr") return fr_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "it") return it_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "hu") return hu_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "nl") return nl_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "no") return no_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "pl") return pl_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "pt") return pt_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "ro") return ro_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "fi") return fi_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "sv") return sv_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "vi") return vi_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "tr") return tr_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "cs") return cs_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "bg") return bg_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "ru") return ru_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "uk") return uk_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "ar") return ar_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "hi") return hi_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "th") return th_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "ja") return ja_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "zh-CN") return zh_cn2_privacy_fairusefactors_noncommercialbody4(inputs)
	if (locale === "zh-Hant") return zh_hant1_privacy_fairusefactors_noncommercialbody4(inputs)
	return ko_privacy_fairusefactors_noncommercialbody4(inputs)
});
export { privacy_fairusefactors_noncommercialbody4 as "privacy.fairUseFactors.nonCommercialBody" }